import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import CheckCircle from '@mui/icons-material/CheckCircle';

const ZatcaPhase = ({ zatcaStatus, onUpgrade }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // If Phase 2 compliant, show success badge
  if (zatcaStatus?.isCompliant && zatcaStatus?.phase === 'phase2') {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 1,
          borderRadius: '6px',
          border: '1px solid',
          borderColor: '#e0e0e0',
          bgcolor: '#ffffff',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1.5,
          minWidth: 220,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)'
        }}
      >
        <Box 
          sx={{ 
            display: 'flex', 
            alignItems: 'center',
            gap: 1.5
          }}
        >
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: '6px',
              bgcolor: '#2e7d32',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CheckCircle 
              sx={{ 
                fontSize: '1.25rem',
                color: '#ffffff'
              }} 
            />
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
            <Typography 
              variant="caption" 
              sx={{ 
                fontSize: '0.6rem',
                fontWeight: 600,
                color: 'text.secondary',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                lineHeight: 1
              }}
            >
              ZATCA Phase
            </Typography>
            <Typography
              sx={{
                fontSize: '0.85rem',
                fontWeight: 600,
                color: '#031b4e',
                lineHeight: 1.2
              }}
            >
              Phase 2 Compliant
            </Typography>
          </Box>
        </Box>
      </Paper>
    );
  }

  // Phase 1 - Show upgrade button
  return (
    <Paper
      elevation={0}
      sx={{
        p: 1,
        borderRadius: '6px',
        border: '1px solid',
        borderColor: '#e0e0e0',
        bgcolor: '#ffffff',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1.5,
        minWidth: 320,
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)'
      }}
    >
      {/* Phase Badge */}
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center',
          gap: 1.5
        }}
      >
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: '6px',
            bgcolor: '#1976d2',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography 
            sx={{ 
              fontSize: '0.8rem',
              fontWeight: 700,
              color: '#ffffff'
            }}
          >
            P1
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
          <Typography 
            variant="caption" 
            sx={{ 
              fontSize: '0.6rem',
              fontWeight: 600,
              color: 'text.secondary',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              lineHeight: 1
            }}
          >
            ZATCA Phase
          </Typography>
          <Typography
            sx={{
              fontSize: '0.85rem',
              fontWeight: 600,
              color: '#031b4e',
              lineHeight: 1.2
            }}
          >
            Phase 1
          </Typography>
        </Box>
      </Box>

      {/* Divider */}
      <Box 
        sx={{ 
          width: '1px', 
          height: '32px', 
          bgcolor: '#e0e0e0' 
        }} 
      />

      {/* Upgrade Button */}
      <Button
        variant="contained"
        onClick={onUpgrade}
        endIcon={<ArrowUpwardIcon sx={{ fontSize: '0.8rem' }} />}
        size="small"
        sx={{
          bgcolor: '#1976d2',
          color: '#ffffff',
          '&:hover': {
            bgcolor: '#1565c0',
          },
          textTransform: 'none',
          fontWeight: 600,
          px: 2,
          py: 0.5,
          fontSize: '0.75rem',
          minWidth: 'auto',
          whiteSpace: 'nowrap',
          borderRadius: '5px',
          boxShadow: 'none'
        }}
      >
        Upgrade to Phase 2
      </Button>
    </Paper>
  );
};

export default ZatcaPhase;